export const BACKGROUND_FLEET_DATA = 0;
export const BACKGROUND_MARKET_DATA = 1